<template>
  <c-menu ref="menu" :list="list" :underline="value" readonly>
    <template v-slot:default="{ classList }">
      <c-input
        v-model="value"
        :class="classList"
        :placeholder="translations['search-placeholder']"
        icon="search"
        @click="onClick"
      />
    </template>
  </c-menu>
</template>

<script>
import CInput from '@/components/CInput'
import CMenu from '@/components/CMenu'
import { ref } from 'vue'
import { useStore } from 'vuex'
import Translation from 'dcode/classes/Translation'
import getExp from 'dcode/functions/getExp'
import useWatch from 'dcode/uses/useWatch'

export default {
  name: 'CSearch',
  components: {
    CInput,
    CMenu
  },
  setup () {
    const store = useStore()
    const translations = Translation.getByList(['search-placeholder'])
    const menu = ref(undefined)
    const value = ref('')
    const list = useWatch(value, async data => {
      data.value = value.value.length > 2
        ? store.getters.getElements.filter(
          item => item.tags?.match(getExp(value.value)) || item.text?.match(getExp(value.value))
        )
        : []

      menu.value.window.toggle(data.value.length > 0)
    }, [], [])

    const onClick = () => {
      if (menu.value.window.open) {
        menu.value.window.toggle(false)
      } else if (list.value.length > 0) {
        menu.value.window.toggle(true)
      }
    }

    return {
      translations,
      menu,
      value,
      list,
      onClick
    }
  }
}
</script>

<style lang="scss"/>
